export default __webpack_public_path__ + "static/media/KakaoTalkHead.376893b2.png";